export default {
  tabs: {
    gift_cards: 'Cartões de oferta',
    settings: 'Definições',
  },
  gift_cards: {
    title: 'Cartões de oferta',
    subtitle: 'Gerir todos os cartões de oferta do seu restaurante',
    buttons: {
      create: 'Criar cartão de oferta',
      redeem: 'Resgatar cartão de oferta',
      check_balance: 'Verificar saldo',
    },
    search: {
      placeholder: 'Introduza texto de pesquisa',
    },
    columns: {
      code: 'Código',
      status: 'Estado',
      balance: 'Saldo',
      value: 'Valor',
      email: 'Comprador',
      source: 'Origem',
      created_at: 'Criado',
    },
    statuses: {
      active: 'Ativo',
      partially_redeemed: 'Parcialmente Resgatado',
      redeemed: 'Resgatado',
    },
  },
  settings: {
    gift_cards_availability: {
      title: 'Definições do Cartão de Oferta',
      subtitle: 'Configure as opções do cartão de oferta para o seu restaurante',
      availability: {
        title: 'Ativar Cartões de Oferta',
        subtitle: 'Permitir que os clientes comprem e resgatem cartões de oferta',
        buttons: {
          enable: 'Ativar',
          disable: 'Desativar',
        },
      },
    },
    redemption_options: {
      title: 'Opções de Resgate',
      subtitle: 'Escolha onde os clientes podem resgatar cartões de oferta',
      redemption_mode: {
        title: 'Modo de Resgate',
        subtitle: 'Isto afeta o texto apresentado na página de destino do cartão de oferta',
        buttons: {
          online: 'Apenas online',
          online_and_store: 'Online e na loja',
        },
      },
    },
  },
  summary: {
    total_value: 'Valor Total',
    total_active: 'Total Ativo',
    redeemed_this_month: 'Resgatado Este Mês',
  },
};
